AppHeaderComponent.$inject = ['$scope', 'hUser', '$q', 'brandServices', 'userPermissions', '$state', '$element', 'appLayoutViewService', 'hTransitions', 'userPreferencesManagerService', 'useShortcutsNavFactory', 'genAiService'];

function AppHeaderComponent($scope, hUser, $q, brandServices, userPermissions, $state, $element, appLayoutViewService, hTransitions, userPreferencesManagerService, useShortcutsNavFactory, genAiService) {

    var self = this;

    const {
        getShortcutsNavItems
    } = useShortcutsNavFactory($scope);

    self.isFromUK = true;
    self.searchView = false;
    self.searchDropdownOpen = false;
    self.searchInFocus = false;
    self.isLMSElearningServiceEnabled =  false;
    self.isNewsFeedServiceEnabled = false;
    self.canAccessLiveSchedule = false;
    let userPreferenceNavigationEvent;
    self.hasAccessToSourceHire = false;
    let brandThemeEvent;
    self.isBrandsListShown = false;
    self.isSalliSideBarOpen = genAiService.isSalliSideBarOpen;

    let agentSideBarHandler;


    var updateSearchView = function () {
        if (!self.searchInFocus && !self.searchDropdownOpen) {
            self.searchView = false;
        }
    };

    const checkActiveBrandItemsVisibility = (brandId) => {
        const defer = $q.defer();
        self.isNewsFeedServiceEnabled = false;

        brandServices.check(brandServices.SERVICES.NEWS_FEED, brandId)
            .then((isNewsFeedServiceEnabled) => {
                self.isNewsFeedServiceEnabled = isNewsFeedServiceEnabled;
                defer.resolve();
            })
            .catch((err) => console.error(err));

        return defer.promise;
    };

    var checkHeaderItemsVisibility = function () {
        self.loadingServices = true;
        const brandIds = hUser.data.user.brands_list?.map((brand) => brand.id) || [];
        self.isCommsHubEnabled = false;
        self.isCustomDashEnabled = false;
        self.isTTSDashboardEnabled = false;
        self.hasSalesAccess = hUser.hasSalesAccess();
        self.isTSServiceEnabled = false;
        self.isCoreHRServiceEnabled = false;

        if (brandIds.length !== 1) {
            brandIds.push(hUser.getUserContext()['brand_id']);
        }

        getShortcutsNavItems()
            .then(items => self.shortcutNavItems = items)
            .catch(err => {
                self.shortcutNavItems = [];
                console.error(err);
            });

        var promises = {
            brandServicesCheck: brandServices.checkAll(brandIds[0], [
                brandServices.SERVICES.ENTERPRISE_COMMUNICATION,
                brandServices.SERVICES.CUSTOM_DASHBOARD,
                brandServices.SERVICES.TTS_DASHBOARD,
                brandServices.SERVICES.HARRI_ENGAGE,
                brandServices.SERVICES.ONBOARDING_JOURNEY,
            ], true),
            isADAMServiceEnabled: brandServices.check(brandServices.SERVICES.ADAM, hUser.getEntryMode().brand_id, true),
            policyParser: userPermissions.getBrandPolicy(brandIds),
            isTSServiceEnabled: brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, hUser.getEntryMode().brand_id, true),
            isCoreHRServiceEnabled: brandServices.check(brandServices.SERVICES.CORE_HR, hUser.getEntryMode().brand_id, true),
            activeBrandServicesCheck: checkActiveBrandItemsVisibility(hUser.getActiveBrandId()),
        };

        $q.all(promises)
            .then(async function (res) {
                var services = res.brandServicesCheck;
                self.isADAMServiceEnabled = res.isADAMServiceEnabled;
                self.hasManageAdamPermission = res.policyParser.has(userPermissions.PERMISSIONS.MANAGE_ADAM);
                self.isCommsHubEnabled = services[brandServices.SERVICES.ENTERPRISE_COMMUNICATION];
                self.isCustomDashEnabled = services[brandServices.SERVICES.CUSTOM_DASHBOARD];
                self.isTTSDashboardEnabled = services[brandServices.SERVICES.TTS_DASHBOARD];
                self.hasAccessToSourceHire = res.policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);
                self.hasAccessToTeam = res.policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                self.isTSServiceEnabled = res.isTSServiceEnabled;
                self.isCoreHRServiceEnabled = res.isCoreHRServiceEnabled;

                if (self.isCommsHubEnabled) {
                    TeamCommunicationAPI.getUnreadMessagesCount()
                        .then(function (count) {
                            self.unseenMessagesCount = count;
                        });
                }

                if (services[brandServices.SERVICES.HARRI_ENGAGE]) {
                    TeamCommunicationAPI.getUnreadMessagesByModule("HARRI_ENGAGE")
                        .then(function (brands) {
                            self.hasNotifications = !!brands?.length;
                        });
                }

                if (services[brandServices.SERVICES.ONBOARDING_JOURNEY]) {
                    const unreadEvents = await OnBoardingJourneyAPI.getUnreadEvents();
                    self.hasNotifications = unreadEvents.length > 0;
                    $scope.$digest();
                }

                self.loadingServices = false;
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    self.toggleNewsFeed = () => {
        self.isNewsFeedShown = !self.isNewsFeedShown;

        if (self.isNewsFeedShown) {
            $(document).on("click.news-feed-dropdown", function (event) {
                if ($(event.target).parents(".news-feed-dropdown").length === 0) {
                    self.isNewsFeedShown = false;
                    $scope.$digest();
                }
            });
        }
    };

    self.clearUserContext = () => {
      if (!hUser.isTopLevelContext() && hUser.isHMAPUser()) {
          hUser.clearUserContext();
      }
    };

    self.onBrandSelected = (brand) => {
        const defer = $q.defer();

        self.isBrandsListShown = false;
        appLayoutViewService.handleBrandChange(brand)
            .finally(() => {
                defer.resolve();
            });

        return defer.promise;
    };

    const getActiveBrandId = () => {
        let brandId;

        if (!hUser.isTopLevelContext() && hUser.data.user.brands_list?.length === 1) {
            brandId = hUser.data.user.brands_list[0].id
        } else {
            if (hUser.isTopLevelContext()) {
                brandId = hUser.getActiveBrandId();
            } else {
                brandId = hUser.getActiveBrandIdWithAccess();
            }
        }

        return brandId;
    };

    self.$onInit = async () => {
        self.activeBrandId = getActiveBrandId();
        self.isHMAPUser = hUser.isHMAPUser();
        self.entryBrandId = hUser.data.user.entry_mode && hUser.data.user.entry_mode.brand_id;
        userPreferencesManagerService.getDashboardRoute(true)
            .then((homePageRoute) => {
                self.homePageRouteName = homePageRoute.name;
                self.homePageUrl = homePageRoute.href;
                self.redirectToWorkspace = homePageRoute.redirectToWorkspace;
            })
            .catch((err) => console.error(err));

        self.isLMSElearningServiceEnabled = false;

        agentSideBarHandler = genAiService.onSalliSideBarStateChange((isOpen) => {
            self.isSalliSideBarOpen = isOpen;
            $scope.$digest();
        });

        hUser.isFromUK()
            .then(function (isFromUK) {
                self.isFromUK = !!isFromUK;
            });

        var servicesPromises = {
            brandServicesChecks: brandServices.checkAll(hUser.getEntryMode().brand_id, [brandServices.SERVICES.HARRI_ACADEMY]),
            isTeamSchedulingEnabled: brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, hUser.getEntryMode().brand_id, true)
        };

        $q.all(servicesPromises)
            .then(function (result) {
                var brandServicesChecks = result.brandServicesChecks;
                var isTeamSchedulingEnabled = result.isTeamSchedulingEnabled;
                self.isLMSElearningServiceEnabled = brandServicesChecks[brandServices.SERVICES.HARRI_ACADEMY];

                if (self.isLMSElearningServiceEnabled) {
                    var innerPromises = {
                        academyLink: UserAPI.getAcademyLink(),
                    };

                    $q.all(innerPromises)
                        .then(function (res) {
                            self.academyRedirectionLink = res.academyLink && res.academyLink.redirection_link;
                        });
                }

                if (isTeamSchedulingEnabled) {
                    LiveScheduleAPI.checkIfBrandHasAvailableShiftsEmailsService(hUser.getEntryMode().brand_id)
                        .then(function (availableShiftsEnabled) {
                            self.canAccessLiveSchedule = availableShiftsEnabled;
                        })
                        .finally(function () {
                            $scope.$evalAsync();
                        });
                }
            });
        var promises = {
            'userMedia': UserAPI.getUserBasicMedia(),
        };

        $q.all(promises)
            .then(function (res) {
                self.user = {
                    id: hUser.data.user.id,
                    display_name: hUser.data.user.first_name,
                    first_name: hUser.data.user.first_name,
                    last_name: hUser.data.user.last_name,
                    email: hUser.data.user.email,
                    image_uuid: res.userMedia['user_profile']['uuid']
                };
            })
            .catch(function (err) {
                console.error(err);
            });

        brandThemeEvent = appLayoutViewService.on('theme_update', function (brandTheme) {
            setHeaderTheme(brandTheme);
        });

        userPreferenceNavigationEvent = userPreferencesManagerService.on(userPreferencesManagerService.EVENTS.USER_PREFERENCE_NAVIGATION_UPDATED, async () => {
            const homePageRoute = await userPreferencesManagerService.getDashboardRoute(true);
            self.homePageRouteName = homePageRoute.name;
            self.homePageUrl = homePageRoute.href;
            self.redirectToWorkspace = homePageRoute.redirectToWorkspace;
            $scope.$digest();
        });

        setHeaderTheme(appLayoutViewService.getBrandTheme());
        checkHeaderItemsVisibility();
    };

    var setHeaderTheme = function (brandTheme) {
        if (
            !brandTheme?.scheme_settings?.background_color ||
            ColorUtils.normalizeHex(brandTheme.scheme_settings.background_color).toUpperCase() === 'FFFFFF'
        ) {
            $element.find('.app-header').addClass('white-header');
        } else {
            $element.find('.app-header').removeClass('white-header');
        }
    };

    self.openSearch = function () {
        self.searchView = true;
    };

    self.closeSearch = function () {
        self.searchView = false;
    }

    self.searchDropdownToggeled = function (isShown) {
        self.onSearchOpen({isShown: isShown});
        self.searchDropdownOpen = isShown;
        updateSearchView();
    };

    self.onSearchFocusChange = function (isFocused, hasQuery) {
        self.searchInFocus = isFocused;
        updateSearchView();
    };

    self.searchReadyOnView = function () {
        $element.find('#search-input').focus();
    };

    self.toggleSideBar = function (event) {
        event.stopPropagation();
        appLayoutViewService.toggleSideBar(appLayoutViewService.TOGGLE_SOURCE.HEADER);
    };

    self.onDropdownClick = function (event) {
        event.stopPropagation();
    };

    self.toggleLanguageSelector = function (event) {
        event && event.stopPropagation();
        self.isLanguageSelectorShown = !self.isLanguageSelectorShown;
    };

    self.checkIfGPContext = function () {
        return hUser.isTopLevelContext();
    };

    self.getEditProfileHref = () => {
        if (!self.hasAccessToSourceHire && !hUser.isTopLevelContext()) {
            return $state.href('appLayout.schedule.editprofile');
        }

        return $state.href('appLayout.harriSH.editprofile');
    };

    self.getEmploymentProfileHref = () => {
        if (!self.hasAccessToSourceHire && !hUser.isTopLevelContext()) {
            return $state.href('appLayout.schedule.employmentProfile');
        }

        return $state.href('appLayout.harriSH.employmentProfile');
    };

    self.$postLink = function () {
        $element.find('.user-dropdown').on('hidden.bs.dropdown', function () {
            self.isLanguageSelectorShown = false;
            $scope.$digest();
        });
    };

    self.redirectToSupport = function () {
        Utils.redirectToCommunitySupport(true);
    };

    hTransitions.onSuccess({}, async () => {
        const homePageRoute = await userPreferencesManagerService.getDashboardRoute(true);
        self.homePageRouteName = homePageRoute.name;
        self.homePageUrl = homePageRoute.href;
        self.redirectToWorkspace = homePageRoute.redirectToWorkspace;
    });

    self.isActiveLink = function (stateName) {
        return $state.current.name === stateName;
    };

    self.isSideBarExpanded = function () {
        return appLayoutViewService.isSideBarExpanded();
    };

    self.getToggleSource = function () {
        return appLayoutViewService.getToggleSource();
    };

    self.onBrandsListDropdownToggle = (isBrandsListShown) => {
        self.isBrandsListShown = isBrandsListShown;

        if (self.isBrandsListShown) {
            $(document).on("click.brands-list", function (event) {
                if ($(event.target).parents(".h-brands-list-container").length === 0) {
                    self.isBrandsListShown = false;
                    $scope.$digest();
                }
            });
        }
    };

    const brandsListUpdatedEvent = hUser.onBrandsListUpdated(() => {
        self.activeBrandId = getActiveBrandId();
        checkActiveBrandItemsVisibility(hUser.getActiveBrandIdWithAccess());
        getShortcutsNavItems()
            .then(items => self.shortcutNavItems = items)
            .catch(err => {
                self.shortcutNavItems = [];
                console.error(err);
            });
    });

    self.canViewGlobalSearch = () => {
        return ($state.current.showGlobalSearch && (self.hasAccessToSourceHire || hUser.isHMAPUser()));
    };

    $scope.$on('$destroy', function () {
        brandThemeEvent && appLayoutViewService.off(brandThemeEvent);
        userPreferenceNavigationEvent && userPreferencesManagerService.off(userPreferenceNavigationEvent);
        hUser.off(brandsListUpdatedEvent);
        genAiService.off(agentSideBarHandler);
        $(document).off("click.brands-list");
        $(document).off("click.news-feed-dropdown");
    });
}

angular
    .module("harriApp")
    .component("appHeader", {
        controller: AppHeaderComponent,
        bindings: {
            onSearchOpen: '&',
            canViewSalli: '<',
            toggleSalli: '&'
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/harri-main/components/app-header/app-header.component.html'
    });